import { Reveal, SectionTag, SectionHeading } from "@/components/landing/Reveal";
import { useLang } from "@/lib/i18n";

const PROBLEMS = [
  { number: "01", titleKey: "problem.c1t", descKey: "problem.c1d", testid: "problem-card-hemsida" },
  { number: "02", titleKey: "problem.c2t", descKey: "problem.c2d", testid: "problem-card-intryck" },
  { number: "03", titleKey: "problem.c3t", descKey: "problem.c3d", testid: "problem-card-narvaro" },
];

export default function Problem() {
  const { t } = useLang();
  return (
    <section id="problem" data-testid="problem-section" className="bg-ink py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionTag number="01" label={t("problem.tag")} />
        <div className="grid gap-10 lg:grid-cols-2 lg:items-end">
          <SectionHeading>{t("problem.heading")}</SectionHeading>
          <Reveal delay={0.15}>
            <p className="max-w-md text-base leading-relaxed text-fog lg:ml-auto">
              {t("problem.text")}
            </p>
          </Reveal>
        </div>
        <div className="mt-16 grid gap-10 md:grid-cols-3 md:gap-8">
          {PROBLEMS.map((p, i) => (
            <Reveal key={p.number} delay={0.1 + i * 0.12}>
              <article
                data-testid={p.testid}
                className="group border-t-2 border-white/15 pt-8 transition-colors duration-500 hover:border-mint"
              >
                <span className="font-mono text-sm text-mint">{p.number}</span>
                <h3 className="mt-4 font-display text-xl font-bold tracking-tight text-bone sm:text-2xl">
                  {t(p.titleKey)}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-fog">{t(p.descKey)}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
